import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.5858 6.58591C23.3668 5.80486 24.6329 5.80486 25.4139 6.58591C26.195 7.36696 26.195 8.63298 25.4139 9.41403L9.41391 25.414C8.63286 26.1951 7.36683 26.1951 6.58579 25.414C5.80474 24.633 5.80474 23.367 6.58579 22.5859L22.5858 6.58591Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.58579 6.58591C7.36683 5.80486 8.63286 5.80486 9.41391 6.58591L25.4139 22.5859C26.195 23.367 26.195 24.633 25.4139 25.414C24.6329 26.1951 23.3668 26.1951 22.5858 25.414L6.58579 9.41403C5.80474 8.63298 5.80474 7.36696 6.58579 6.58591Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgX);
export default ForwardRef;
